import { Platform } from 'react-native';
// Helper for web-specific styles to ensure transitions are applied correctly
const webTransition = (property, duration = '150ms', timing = 'ease-in-out') => {
  if (Platform.OS === 'web') {
    return { transition: `${property} ${duration} ${timing}` };
  }
  return {};
};

export default webTransition;